"use client";
import * as React from "react";
import { useState } from "react";
import type { ToggleDirectoryStatusProps, Directory } from "../types";
import ToggleSwitch from "../../shared/ToggleSwitch/index";
import defaultClasses from "./index.module.css";
import cssClassAssembler from "../../sso/utils/cssClassAssembler";
import ConfirmationPrompt from "../../shared/ConfirmationPrompt/index";
import { sendHTTPRequest } from "../../shared/http";

function ToggleConnectionStatus(props: ToggleDirectoryStatusProps) {
  const [displayPrompt, setDisplayPrompt] = useState(() => false);

  function connectionStatus() {
    return props.connection?.deactivated ? "Inactive" : "Active";
  }

  function connectionAction() {
    return props.connection?.deactivated ? "activate" : "deactivate";
  }

  function askForConfirmation() {
    setDisplayPrompt(true);
  }

  function onCancel() {
    setDisplayPrompt(false);
  }

  function onConfirm() {
    updateConnectionStatus(!props.connection?.deactivated);
  }

  function classes() {
    return {
      container: cssClassAssembler(
        props.classNames?.container,
        defaultClasses.container
      ),
    };
  }

  function updateConnectionStatus(status: boolean) {
    async function toggle() {
      const body = {
        directoryId: props.connection?.id,
        deactivated: status,
      };
      const response = await sendHTTPRequest<{
        data: Directory;
      }>(props.urls.patch, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      setDisplayPrompt(false);
      if (response && typeof response === "object") {
        if ("error" in response && response.error) {
          typeof props.errorCallback === "function" &&
            props.errorCallback(response.error.message);
        } else {
          typeof props.successCallback === "function" &&
            props.successCallback({
              operation: "UPDATE",
            });
        }
      }
    }
    toggle();
  }

  return (
    <>
      {props.connection !== undefined || props.connection !== null ? (
        <>
          <div className={classes().container}>
            {displayPrompt ? (
              <ConfirmationPrompt
                ctoaVariant={
                  props.connection?.deactivated ? "primary" : "destructive"
                }
                classNames={props.classNames?.confirmationPrompt}
                cancelCallback={onCancel}
                confirmationCallback={onConfirm}
                promptMessage={`Do you want to ${connectionAction()} the connection?`}
              />
            ) : null}
            {!displayPrompt ? (
              <ToggleSwitch
                label={connectionStatus()}
                disabled={displayPrompt}
                checked={!props.connection?.deactivated}
                handleChange={askForConfirmation}
              />
            ) : null}
          </div>
        </>
      ) : null}
    </>
  );
}

export default ToggleConnectionStatus;
